import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './styles/tailwind.css';

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    window.dispatchEvent(
      new CustomEvent('pwa-need-refresh', {
        detail: updateSW,
      })
    );
  },
  onOfflineReady() {
    console.info('Patel Sales app is ready for offline use.');
  },
  onRegisteredSW(_swUrl, registration) {
    if (registration) {
      // Ensure an active worker controls this page ASAP (needed for install prompt)
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      setInterval(() => registration.update(), 60 * 60 * 1000);
    }
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
